var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.376 7.293-7.12 7.12a.85.85 0 0 0-.256.624.85.85 0 0 0 .257.623l.807.808a.85.85 0 0 0 .624.257.74.74 0 0 0 .624-.22L12 10.816l5.688 5.688q.257.258.624.22a.85.85 0 0 0 .624-.256l.807-.808a.85.85 0 0 0 .257-.623.85.85 0 0 0-.257-.624l-7.12-7.12A.8.8 0 0 0 12 7a.8.8 0 0 0-.624.293"
  })));
};
export default SvgChevronUp;